import { render, staticRenderFns } from "./StartseiteQS.vue?vue&type=template&id=6c7e2dee&"
import script from "./StartseiteQS.vue?vue&type=script&lang=js&"
export * from "./StartseiteQS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports